<template>
    <div class="blackBg">
        <div class="cardTit">
            <span class="teamName">{{teamName?teamName:'XXX'}}</span>
            <span class="injuryNum" v-if="type=='injury'"><em>伤病数</em> <i>{{infoPlayerList.length}}</i></span>
        </div>
        <div class="playerList">
            <ul v-if="playerList.length">
                <li v-for="(i,index) in playerList" :class="[(amplification)?'amplification':'',fadein]" @click="routeFn(i, false)">
                    <p class="playerImg">
                        <span class="number">{{index+1}}</span>
                        <span class="imgCardBox">
<!--                            <playerCard class="imgCard" width="100%" height="20vw" background="none" :img-url="require('@/assets/img/headImg.svg')"></playerCard>-->
                            <playerCard class="imgCard" width="100%" height="20vw" background="none"
                                        :img-url="i?i.avatar:''"></playerCard>
                        </span>
                    </p>
                    <p class="playerMsg">
<!--                        <span class="num" v-if="i.number" :class="type=='injury' && i.injury ? 'red' : ''">{{i?i.number:''}}</span>-->
                        <span class="name">{{i?i.name:''}}</span>
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import playerCard from "./playerCard";

    export default {
        name: "newPlayerList",
        components: {
            playerCard
        },
        props: {
            type: String
        },
        data() {
            return {
                teamName: this.$store.state.teamName ? this.$store.state.teamName.split('_')[0] : '',//梯队名称
                teamValue: '',//球队
                infoPlayerList: [],//初始球员列表
                playerList: [],//当前渲染的球员列表
                amplification: false,//切换图片时动效
                fadein: '',//切换图片时动效
                domTime: null,//动效定时器
            }
        },
        computed: {
            lookCommandFn() {
                return this.$store.state.lookCommand;
            },
            teamIdFn() {
                return this.$store.state.teamId;
            }
        },
        watch: {
            lookCommandFn: {
                handler(val, old) {
                    let playerList = this.playerList;//当前渲染的球员列表 y用于编号查看
                    let infoPlayerList = this.infoPlayerList;//球员list
                    let flag = 0;
                    for (let i = 0; i < playerList.length; i++) {
                        if (eval('/' +  this.$aiJson.itemNum[i] + '号' + '/gi').test(val)) {
                            this.routeFn(playerList[i])
                            flag = 1;
                            return false;
                        } else {
                            flag = 0;
                        }
                    }
                    if(!flag){
                        for (let i = 0; i < infoPlayerList.length; i++) {
                            if (eval('/' +  infoPlayerList[i].name + '/gi').test(val)) {
                                this.routeFn(infoPlayerList[i])
                                flag = 1;
                                return false;
                            } else {
                                flag = 0;
                            }
                        }
                    }
                    if (!flag) {
                        this.$store.dispatch("setFlag", '0_' + new Date().getTime());//vuex改变识别信息
                    }
                },
                deep: true
            },
            teamIdFn(val, old) {
                if (val != old) {
                    this.teamName = this.$store.state.teamName.split('_')[0]
                    this.seleChangeGn()
                }
            },
            //dom动效
            amplification: {
                handler(val, old) {
                    if (val) {
                        let timeChild = null;
                        timeChild = setTimeout(() => {
                            this.amplification = false;
                            clearInterval(timeChild)
                        }, 10000)
                    }
                    setTimeout(() => {
                        this.fadein = ''
                    }, 1000)
                }
            }
        },
        mounted() {
            this.seleChangeGn()
        },
        methods: {
            info() {
                this.$server.getTeamList({id: this.$store.state.userId}).then((res) => {
                    this.teamListOptions = [];
                    for (let i = 0; i < res.data.length; i++) {
                        this.teamListOptions.push({
                            value: res.data[i].id + '_' + res.data[i].name,
                            label: res.data[i].name
                        })
                    }
                    this.teamValue = res.data[0].id + '_' + res.data[0].name;
                    this.seleChangeGn();
                })
            },
            seleChangeGn() {
                let data = {
                    teamId: this.$store.state.teamId,//球队id
                    // teamId: '5fbb328e99853c35e99eb2cb',
                }
                if (this.type == 'coach' || this.type == 'coachAssessment') {
                    this.$server.getTeamStaff(data).then((res) => {
                        this.infoPlayerList = res.data;
                        clearInterval(this.domTime)
                        this.domFn()
                    })
                } else if (this.type == 'injury') {
                    this.$server.injuryList(data).then((res) => {
                        this.infoPlayerList = res.data.player;
                        clearInterval(this.domTime)
                        this.domFn()
                    })
                } else {
                    this.$server.getPlayersList(data).then((res) => {
                        this.infoPlayerList = res.data;
                        clearInterval(this.domTime)
                        this.domFn()
                    })
                }
            },
            //dom渲染
            domFn() {
                let length = 12;
                if (this.infoPlayerList.length > 12) {
                    this.playerList = this.infoPlayerList.slice(0, length);
                    this.domTime = setInterval(() => {
                        this.amplification = true;
                        this.fadein = 'a-fadein1_5';
                        let lastInx = this.infoPlayerList.indexOf(this.playerList[this.playerList.length - 1]);
                        this.playerList = [];

                        if ((lastInx + length) < this.infoPlayerList.length) {
                            this.playerList = this.infoPlayerList.slice(lastInx, lastInx + length);
                        } else {
                            this.playerList = this.infoPlayerList.slice(lastInx, this.infoPlayerList.length);
                            let allLen = (lastInx + length);//总长度
                            // console.log(allLen)
                            let needSplitLet = allLen - this.infoPlayerList.length;//需要从前截取的长度
                            let beforeArr = this.infoPlayerList.slice(0, needSplitLet);
                            this.playerList = this.playerList.concat(beforeArr)
                            return;
                        }

                    }, 10000)
                } else {
                    this.playerList = this.infoPlayerList;
                }
            },
            //路由跳转
            routeFn(item, flag) {
                flag ? this.$store.dispatch("setFlag", '1_' + new Date().getTime()) : '';//vuex改变识别信息
                let routerObj = {};
                if (this.type == 'assessment') {//评估
                    routerObj = {
                        path: '/about/assessmentReportDetail',
                        name: 'assessmentReportDetail',
                        params: {
                            id: item.id,
                            position: item.courtPosition
                        },
                        goType: 1
                    }
                } else if (this.type == 'player') {//球员列表
                    routerObj = {
                        path: '/about/playersDetail',
                        name: 'playersDetail',
                        params: {
                            id: item.id,
                            position: item.courtPosition
                        },
                        goType: 1
                    }
                } else if (this.type == 'injury') {//球员列表
                    routerObj = {
                        path: '/about/injuryDetail',
                        name: 'injuryDetail',
                        params: {
                            id: item.id,
                            injuryImg: item.injuryImg,
                            number: item.number
                        },
                        goType: 1
                    }
                } else if (this.type == 'AC_report') {//球员列表
                    routerObj = {
                        path: '/about/dataReport/AC_reportDetail',
                        name: 'dataReport/AC_reportDetail',
                        params: {
                            id: item.id,
                            name: item.name
                        },
                        goType: 1
                    }
                } else if (this.type == 'coach') {//教练员列表
                    routerObj = {
                        path: '/about/coachDetail',
                        name: 'coachDetail',
                        params: {
                            id: item.id,
                            name: item.name
                        },
                        goType: 1
                    }
                } else if (this.type == 'intensity') {
                    routerObj = {
                        path: '/about/dataReport/intensityReportDetail',
                        name: 'dataReport/intensityReportDetail',
                        params: {
                            id: item.id,
                            name: item.name
                        },
                        goType: 1
                    }
                } else if (this.type == 'AC_AIM') {
                    routerObj = {
                        path: '/about/dataReport/AC_AIM_Detail',
                        name: 'dataReport/AC_AIM_Detail',
                        params: {
                            id: item.id,
                            name: item.name
                        },
                        goType: 1
                    }
                } else if (this.type == 'match_day') {
                    routerObj = {
                        path: '/about/dataReport/match_day_detail',
                        name: 'dataReport/match_day_detail',
                        params: {
                            id: item.id,
                            name: item.name,
                        },
                        goType: 1
                    }
                } else if (this.type == 'coachAssessment') {
                    routerObj = {
                        path: '/about/coachAssessmentDetail',
                        name: 'coachAssessmentDetail',
                        params: {
                            id: item.id,
                            name: item.name,
                            nameEn: item.nameEn
                        },
                        goType: 1
                    }
                } else if (this.type === 'player_data') {
                    routerObj = {
                        path: '/about/dataReport/player_data_detail',
                        name: 'dataReport/player_data_detail',
                        params: {
                            id: item.id,
                            name: item.name,
                        },
                        goType: 1
                    }
                }
                // this.$store.state.promptMsg='返回，或者 回到开始'
                this.$store.dispatch("setRouter", routerObj);//vuex改变路由
                this.$router.push(routerObj);
                clearInterval(this.domTime);
            }
        }
    }
</script>

<style scoped lang="less">
    .cardTit {
        background-image: url("../assets/img/updateImg/head_4.png");
        margin-bottom: 20px;
        margin-top: 1vw;
        position: relative;

        .injuryNum {
            color: #fff;
            position: absolute;
            left: 2vw;
            font-size: 30px;
            line-height: 120px;

            em, i {
                font-style: normal;
                float: left;
            }

            i {
                font-size: 48px;
                color: #E46A6A;
                font-family: akrobatBold;
                margin-left: .5vw;
            }
        }
    }

    .playerList {
        ul {
            li {
                transition: all 1.5s; /*所有属性变化在0.6秒内执行动画*/
                width: calc((100% - (.8vw * 5)) / 6);
                margin-left: .8vw;
                margin-bottom: 4vw;
                float: left;

                &:first-child, &:nth-child(7) {
                    margin-left: 0;
                }

                .playerMsg {
                    color: #fff;
                    text-align: center;
                    /*background-color: rgba(27, 27, 27, .6);*/
                    background-image: url("../assets/img/updateImg/playerMsg.svg");
                    background-size: 100%;
                    background-repeat: no-repeat;
                    height: 3.5vw;
                    line-height: 3.3vw;
                    box-sizing: border-box;
                    width: 100%;
                    display: flex;
                    justify-content:center;

                    .num {
                        color: var(--primary-color);
                        font-size: 35px;
                        font-family: akrobatBold;
                        padding-right: .5vw;
                        &.red {
                            color: #E46A6A;
                        }
                    }

                    .name {
                        font-size: 24px;
                        /*width: calc(100% - 2vw);*/
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                }

                .playerImg {
                    text-align: center;
                    height: 9.5vw;
                    background-color: rgba(27, 27, 27, .6);
                    position: relative;
                    .number{
                        border: 2px solid rgba(255, 255, 255, 0.3);
                        width: 2vw;
                        height: 2vw;
                        background-color: var(--primary-color);
                        border-radius: 50%;
                        text-align: center;
                        line-height: 1.8vw;
                        font-size: 24px;
                        position: absolute;
                        font-family: akrobatBold;
                        top: .2vw;
                        left: .2vw;
                        z-index: 1;
                        color: #fff;
                    }
                    .imgCardBox {
                        width: 100%;
                        /*transform:scale(1.2);*/
                        display: inline-block;
                        height: 100%;
                        position: relative;
                    }

                    .imgCard {
                        /*position: absolute;*/
                        /*top: -47%;*/
                        /*left: -0%;*/
                    }
                }
            }
        }
    }

    .amplification {
        display: inline-block;
        width: 100%;
        height: 100%;
        transform: rotateY(360deg);
    }
</style>
